import size from 'lodash/size';
import find from 'lodash/find';
import forOwn from 'lodash/forOwn';
import modelTree from "~/selectors/modelTree";
import loadModels from "~/reducers/helpers/loadModels";
import identify from "~/identify";

const ensureItemSubviewsAreLoaded = (loadedModels, props) => {
    let { parentModelId, itemId, modelName, getModelOrNull, getSubviewsByModelName, getRelationshipFieldsByModelName } = props;

    if(!itemId) { return loadedModels; }
    let subviews = getSubviewsByModelName(modelName);
    
    if(!size(subviews)) { return loadedModels; }

    let tree = modelTree(loadedModels),
        childModels = tree.getChildren(parentModelId),
        modelsToLoad = [];  

    forOwn(subviews, ({name, model}) => {
        if(!find(childModels, { subviewName: name })) {
            
            modelsToLoad.push({
                modelId: tree.getTreeId(model, parentModelId),
                parentModelId: parentModelId,
                modelName: model,
                data: {
                    subviewName: name,
                    view: identify.VIEW_SUBVIEW,
                }
            });
            
        }
    });

    return loadModels(loadedModels, { models: modelsToLoad, getSubviewsByModelName, getModelOrNull, getRelationshipFieldsByModelName} );
};

export default ensureItemSubviewsAreLoaded;